<template>
  <div :class="dividerClass">
    <span v-if="text && orientation !== 'center'" :class="`${prefixCls}-text ${prefixCls}-text-${orientation}`">
      {{ text }}
    </span>
    <div :class="`${prefixCls}-inner`" :style="dividerStyle">
      <span v-if="text && orientation === 'center'" :class="`${prefixCls}-text ${prefixCls}-text-center`">
        {{ text }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    text: {
      type: String,
      default: ''
    },
    dashed: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      validator(value) {
        return ['left', 'right', 'center'].includes(value);
      },
      default: 'center'
    },
    type: {
      type: String,
      validator(value) {
        return ['horizontal', 'vertical'].includes(value);
      },
      default: 'horizontal'
    }
  },
  computed: {
    prefixCls() {
      return 'divider';
    },
    dividerClass() {
      return [
        this.prefixCls,
        {
          [`${this.prefixCls}-dashed`]: this.dashed,
          [`${this.prefixCls}-${this.type}`]: true
        }
      ];
    },
    dividerStyle() {
      if (this.type === 'horizontal') {
        return { 'border-top': this.dashed ? '1px dashed #e2e2e2' : '1px solid #e2e2e2' };
      } else {
        return { 'border-left': this.dashed ? '1px dashed #e2e2e2' : '1px solid #e2e2e2' };
      }
    }
  }
};
</script>

<style scoped>
.divider {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  color: #e2e2e2;
  line-height: 1;
  white-space: nowrap;
}

.divider-horizontal {
  margin: 16px 0;
}

.divider-vertical {
  min-height: 1em;
  margin: 0 16px;
}

.divider-inner {
  flex: 1;
}

.divider-text {
  display: inline-block;
  padding: 0 16px;
  vertical-align: middle;
}

.divider-text-left {
  padding-left: 0;
}

.divider-text-right {
  padding-right: 0;
}

.divider-dashed .divider-inner {
  border-style: dashed;
}
</style>